import { useState } from 'react';
import { Select } from 'components/common';
import { SelectProps } from 'components/common/select/Select';
import { useServiceTypesOptions } from 'hooks';
import { filterOptions, SERVICE_TYPE_SELECT_ALL } from 'utils';

type IsolatedSelectServiceTypesProps = SelectProps & {
  isAll?: boolean;
  isActive?: boolean;
};

const IsolatedSelectServiceTypes = ({
  isAll = false,
  isActive,
  ...props
}: IsolatedSelectServiceTypesProps) => {
  const [keyword, setKeyword] = useState('');
  const [toggle, setToggle] = useState(false); // 🔁 dùng để ép refetch

  // Mỗi lần toggle thay đổi => cache key thay đổi => refetch dữ liệu
  const {
    serviceTypesOptions,
    hasMore,
    handleLoadMore,
    resetPage,
    isLoading,
    isFetching
  } = useServiceTypesOptions({
    isActive: toggle ? true : false, // ⚠️ ép refetch bằng cách thay đổi cache key
    isLoadAll: true
  });

  const handleSearch = (val: string) => {
    setKeyword(val);
  };

  const handleDropdownVisibleChange = (open: boolean) => {
    if (open) {
      setKeyword('');
      resetPage();
      setToggle((prev) => !prev); // 🔁 trigger refetch
    }
  };

  const data = [
    ...(isAll ? [SERVICE_TYPE_SELECT_ALL] : []),
    ...(serviceTypesOptions.map((itm) => ({
      label: itm.name,
      value: itm.serviceTypeId
    })) || [])
  ];

  const options = filterOptions(data, keyword, 'label');

  return (
    <Select
      {...props}
      onDropdownVisibleChange={handleDropdownVisibleChange}
      onLoadMore={handleLoadMore}
      loading={isLoading || isFetching}
      showSearch
      filterOption={false}
      onSearch={handleSearch}
      hasMore={hasMore}
      options={options}
      style={{
        borderColor:'red',
      }}
    
    />
  );
};

export default IsolatedSelectServiceTypes;
